import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { taxApi } from "../api/taxApi";

export const useTaxData = (stateName, countyId = "") => {
  return useQuery({
    queryKey: ["taxData", stateName, countyId],
    queryFn: () => taxApi.getCountyAndState(stateName, countyId).then(res => res.data.result),
    enabled: !!stateName,
  });
};

export const useUpdateStateTax = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: taxApi.updateStateTax,
    onSuccess: () => {
      toast.success("State specific tax data updated");
      queryClient.invalidateQueries({ queryKey: ["taxData"] });
    },
    onError: (err) => {
      toast.error("Failed to update state tax");
      console.error(err);
    },
  });
};

export const useUpdateState = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: taxApi.updateState,
    onSuccess: () => {
      toast.success("State status updated");
      queryClient.invalidateQueries({ queryKey: ["taxData"] });
    },
    onError: (err) => {
      toast.error("Failed to update state");
      console.error(err);
    },
  });
};

export const useAddCounty = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: taxApi.addNewCounty,
    onSuccess: () => {
      toast.success("County added");
      queryClient.invalidateQueries({ queryKey: ["taxData"] });
    },
    onError: (err) => {
      toast.error("Failed to add county");
      console.error(err);
    },
  });
};

export const useUpdateCountyTax = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: taxApi.updateCountyTax,
    onSuccess: () => {
      toast.success("County data updated");
      queryClient.invalidateQueries({ queryKey: ["taxData"] });
    },
    onError: (err) => {
      toast.error("Failed to update county tax");
      console.error(err);
    },
  });
};

export const useUploadZipCodes = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: taxApi.uploadZipCodes,
    onSuccess: () => {
      toast.success("Zip codes uploaded successfully");
      queryClient.invalidateQueries({ queryKey: ["taxData"] });
    },
    onError: (err) => {
      toast.error("Failed to upload zip codes");
      console.error(err);
    },
  });
};

export const useAddZipCode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: taxApi.addZipCode,
    onSuccess: () => {
      toast.success("Zip code added");
      queryClient.invalidateQueries({ queryKey: ["taxData"] });
    },
    onError: (err) => {
      toast.error("Failed to add zip code");
      console.error(err);
    },
  });
};

export const useUpdateZipCode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: taxApi.updateZipCode,
    onSuccess: () => {
      toast.success("Zip code percentage updated");
      queryClient.invalidateQueries({ queryKey: ["taxData"] });
    },
    onError: (err) => {
      toast.error("Failed to update zip code");
      console.error(err);
    },
  });
};

export const useDeleteZipCode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: taxApi.deleteZipCode,
    onSuccess: () => {
      toast.success("Zip code deleted");
      queryClient.invalidateQueries({ queryKey: ["taxData"] });
    },
    onError: (err) => {
      toast.error("Failed to delete zip code");
      console.error(err);
    },
  });
};

